<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" style="margin-top:88px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item">
            <router-link to="/Exhibitors/Page=1">
              <span class="text-primary">
                Exhibitors
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Exhibitors Search Results</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <div class="PcDevice">
        <div class="d-flex justify-content-between">
          <div class="title_fontStyle  h2"><i class="fas fa-caret-right"></i> Exhibitors Search Results</div>
          <div class="btn btn-primary d-flex justify-content-center align-items-center" @click="OpenModal">
            <i class="fas fa-search mr-2" style="color:white"></i> Advanced Search
          </div>
        </div>
      </div>

      <div class="MbDevice">
        <div class="title_fontStyle  h3 mb-4"><i class="fas fa-caret-right"></i> Exhibitors Search Results</div>
        <div class="btn btn-primary " @click="OpenModal">
          <i class="fas fa-search mr-2" style="color:white"></i> Advanced Search
        </div>
      </div>

      <p>&zwnj;</p>

      <div v-if="hasResult">
        <div class="row">
          <div class="col-lg-3 mt-4" v-for="item in SearchExhibList">
            <div
              class="cardFrame text-center bg-white pointer border card-effect"
              @click.prevent="goExhDetial(item.RegNo)"
            >
              <div class="logImgFrame mt-2">
                <img :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${item.ComLogo}`" alt="" width="65%" />
                <div class="VipTag flicker" v-if="item.VIP == 3">
                  <img src="../../assets/images/vip1.png" width="32px" alt="" />
                </div>
              </div>
              <div class="ComNameFrame mx-2">
                <div style="font-size:15px; font-weight:bold">
                  <div class="ellipsis_exh">
                    {{ item.ComName }}
                  </div>
                </div>
              </div>

              <div class="py-1 border-top" @click.stop="ClickFav(item.RegNo)">
                <span
                  v-show="item.Fav == 1"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Remove from favorites "
                >
                  <img class=" iconOpenHover" src="../../assets/images/liked.png" width="20px" alt="" />
                  <span style="font-size:14px">
                    {{ item.FavCount }}
                  </span>
                </span>
                <span v-show="item.Fav == 0" data-toggle="tooltip" data-placement="bottom" title="Add to favorites ">
                  <img class="iconOpenHover" src="../../assets/images/like.png" width="20px" alt="" />
                  <span style="font-size:14px">
                    {{ item.FavCount }}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- PC版分頁 -->
        <p>&zwnj;</p>
        <p>&zwnj;</p>

        <div class="PcDevice">
          <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center ">
            <nav>
              <ul class="pagination pointer">
                <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                  <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                  </span>
                </li>
                <li class="page-item" :class="{ disabled: currentPage == 1 }">
                  <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                    <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                  </span>
                </li>
                <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                  <span class="page-link" @click="getPage(page)">{{ page }}</span>
                </li>

                <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                  <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                  </span>
                </li>
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                >
                  <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                  </span>
                </li>
              </ul>
              <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
              <p>&zwnj;</p>
            </nav>
          </div>
        </div>
        <div class="MbDevice">
          <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center ">
            <div v-if="currentPage > 10">
              <nav>
                <ul class="pagination pagination-lg pointer">
                  <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                    <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                    </span>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                      <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                    </span>
                  </li>
                  <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                    <span class="page-link" @click="getPage(page)">{{ page }}</span>
                  </li>

                  <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                    <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                    </span>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                    </span>
                  </li>
                </ul>
                <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
              </nav>
            </div>

            <div v-else>
              <nav>
                <ul class="pagination  pagination-sm pointer">
                  <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                    <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                    </span>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                      <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                    </span>
                  </li>
                  <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                    <span class="page-link" @click="getPage(page)">{{ page }}</span>
                  </li>

                  <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                    <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                    </span>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                    </span>
                  </li>
                </ul>
                <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
                <p>&zwnj;</p>
              </nav>
            </div>
          </div>
        </div>

        <p>&zwnj;</p>
        <p>&zwnj;</p>
      </div>

      <div v-else>
        <p>&zwnj;</p>

        <div class="d-flex align-items-center mt-2">
          <div class="mb-3">
            <img src="../../assets/images/Noresult3.png" width="55px" alt="" />
          </div>
          <div class="ml-3">
            <p style="font-size:26px">
              No Result Found
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="SearchModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h2 class="modal-title" id="exampleModalLongTitle">
              <img src="../../assets/images/search_icon.png" width="42px" class="mr-1 mb-1" alt="" />
              Advanced Exhibitor Search
            </h2>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body my-2">
            <label for="exampleInputEmail1" class="h4 mb-3">
              Keyword
            </label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Enter Keyword"
                v-model="TemplateOptionKeyword"
                @keyup.enter="AdvanceSearch()"
              />
              <div class="input-group-append">
                <button
                  class="input-group-text bg-light"
                  type="button"
                  id="exampleInputEmail1"
                  @click="AdvanceSearch()"
                >
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>
            <div v-if="hasExhibAreas">
              <div class="d-flex mt-4 mb-2 align-items-center">
                <h4 class="mt-1">Exhibition Area</h4>
                <div class="btn btn-outline-primary ml-3" style="font-size:14px" @click.prevent="AreaSettingAll">
                  Select All
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 my-1" v-for="item in ExhibAreasList">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      name="checkAll"
                      class="custom-control-input"
                      :value="item.AreaID"
                      :id="item.AreaID"
                      v-model="optionArea"
                    />
                    <label class="custom-control-label" :for="item.AreaID">{{ item.ExhibArea }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex mt-4 mb-2 align-items-center">
              <h4 class="mt-1">Countries/Regions</h4>
              <div class="btn btn-outline-primary ml-3" style="font-size:14px" @click.prevent="CountrySettingAll">
                Select All
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 my-1" v-for="item in CountryList">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    name="checkAll"
                    class="custom-control-input"
                    :id="item.CountryCode"
                    :value="item.CountryCode"
                    v-model="optionCountry"
                  />
                  <label class="custom-control-label" :for="item.CountryCode">{{ item.Country }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer " style="display:inline">
            <div class="d-flex ">
              <button type="button" class="btn btn-primary" @click.prevent="AdvanceSearch()">
                Search
              </button>
              <div class="btn btn-outline-primary ml-2" @click.prevent="delSettingAll">Reset</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        CSRF_Token: '',
        SearchExhibList: [],
        ExhibAreasList: [],
        CountryList: [],

        optionArea: [],
        s_optionArea: '',

        Optioncountry: [],

        s_optionCountry: '',
        optionCountry: [],
        TemplateOptionKeyword: '',

        currentPage: 2,
        totalPage: '',
        totalNo: '',
        ProductRawData: [],
        totaltenPageNum: 0,
        tenPageNum: 0,
        showpage: [],

        hasResult: true,

        categoryAll: [],
        countryAll: [],

        ExhCategory: [],
        hasExhibAreas: false,
      }
    },

    watch: {
      optionArea: function(newValue) {
        this.s_optionArea = newValue.toString()
      },

      optionCountry: function(newValue) {
        this.s_optionCountry = newValue.toString()
      },

      $route(to, from) {
        this.reloadResult()
      },
    },

    methods: {
      OpenModal() {
        $('#SearchModal').modal('show')
      },

      AreaSettingAll() {
        const vm = this
        vm.optionArea = vm.categoryAll
      },

      CountrySettingAll() {
        const vm = this
        vm.optionCountry = vm.countryAll
      },

      delSettingAll() {
        const vm = this

        vm.optionArea = []
        vm.optionCountry = []
        vm.TemplateOptionKeyword = ''
      },

      AdvanceSearch() {
        const vm = this

        vm.$store.dispatch('Savekeyword', vm.TemplateOptionKeyword)
        vm.$store.dispatch('SaveOptionArea', vm.s_optionArea)
        vm.$store.dispatch('SaveOptionCountry', vm.s_optionCountry)
        vm.GetAdvanceSearch()
      },

      GetAdvanceSearch() {
        const vm = this

        vm.$store.dispatch('updateLoading', true)

        //取得過濾後的參展商列表

        vm.currentPage = 1

        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitors/${vm.exhcode}?AreaNo=${vm.SearchArea}&CatNo=&countrycode=${vm.Searchcountry}&keyword=${vm.TemplateOptionKeyword}&Type=null&Page=1&Lang=en&mode=page`
          )
          .then((response) => {
            vm.totalNo = response.data.DataTotal

            if (response.data.PageTotal > 0) {
              vm.hasResult = true

              vm.SearchExhibList = response.data.Exhibitors
              vm.totalPage = response.data.PageTotal
              vm.ProductRawData = []

              for (let i = 0; i < vm.totalPage; i++) {
                if (i % 10 === 0) {
                  vm.ProductRawData.push([])
                }

                const page = parseInt(i / 10)
                vm.ProductRawData[page].push(i + 1)
              }

              vm.totaltenPageNum = vm.ProductRawData.length

              let anaNowPage = vm.currentPage - 1

              vm.tenPageNum = parseInt(anaNowPage / 10)
              vm.showpage = vm.ProductRawData[vm.tenPageNum]

              $('#SearchModal').modal('hide')
              this.$router.push(`/AdvanceSearchExhibitors/Page=${vm.currentPage}`).catch(() => {})

              vm.$store.dispatch('updateLoading', false)
            } else {
              vm.$store.dispatch('updateLoading', false)
              vm.hasResult = false
              alert('No result !')
              $('#SearchModal').modal('hide')
            }
          })
      },

      //點喜愛參展商
      ClickFav(Regno) {
        const vm = this
        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/FavoritesExhibitors/${vm.exhcode}/${Regno}`
        const info = {
          CSRF: vm.CSRF_Token,
        }

        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            vm.reloadResult()
            vm.$bus.$emit('message:push', 'Added to favorites', 'warning')
          } else if (response.data == '252') {
            window.location.replace(`https://www.chanchao.com.tw/en/`)
          } else if (response.data == '251') {
            vm.alertText = 'Server is busy, please try again later.'

            vm.alertError()
          } else if (response.data == '253') {
            vm.reloadResult()
            vm.$bus.$emit('message:push', 'Removed from favorites', 'danger')
          }
        })
      },

      //到參展商詳細頁

      goExhDetial(id) {
        this.$router.push(`/ExhibitorDetail/${id}`)
      },

      //分頁

      getPage(page) {
        const vm = this
        vm.currentPage = page
        vm.$router.push({ path: `/AdvanceSearchExhibitors/Page=${vm.currentPage}` })
        $('html, body').scrollTop(0)

        vm.reloadResult()
      },

      nextPage() {
        const vm = this
        let nextP = Number(vm.currentPage) + 1
        vm.currentPage = nextP

        if (vm.currentPage % 10 == 1) {
          vm.tenPageNum = vm.tenPageNum + 1
          vm.showpage = vm.ProductRawData[vm.tenPageNum]
          vm.currentPage = vm.showpage[0]
        }

        vm.$router.push({ path: `/AdvanceSearchExhibitors/Page=${vm.currentPage}` })
        $('html, body').scrollTop(0)

        vm.reloadResult()
      },

      lastPage() {
        const vm = this
        let lastP = Number(vm.currentPage) - 1
        vm.currentPage = lastP

        if (vm.currentPage % 10 == 0) {
          vm.tenPageNum = vm.tenPageNum - 1
          vm.showpage = vm.ProductRawData[vm.tenPageNum]
          vm.currentPage = vm.showpage[9]
        }

        vm.$router.push({ path: `/AdvanceSearchExhibitors/Page=${vm.currentPage}` })
        $('html, body').scrollTop(0)

        vm.reloadResult()
      },

      nexttenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum + 1
        vm.showpage = vm.ProductRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        vm.$router.push({ path: `/AdvanceSearchExhibitors/Page=${vm.currentPage}` })
        $('html, body').scrollTop(0)

        vm.reloadResult()
      },

      returntenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum - 1
        vm.showpage = vm.ProductRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        vm.$router.push({ path: `/AdvanceSearchExhibitors/Page=${vm.currentPage}` })
        $('html, body').scrollTop(0)

        vm.reloadResult()
      },

      reloadResult() {
        const vm = this

        this.$store.dispatch('updateList', false)

        //將vuex的資料匯出去變數裡

        vm.$store.dispatch('updateLoading', true)

        //取得過濾後的參展商列表

        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitors/${vm.exhcode}?AreaNo=${vm.SearchArea}&CatNo=&countrycode=${vm.Searchcountry}&keyword=${vm.OptionKeyword}&Type=null&Page=${vm.currentPage}&Lang=en&mode=page`
          )
          .then((response) => {
            vm.SearchExhibList = response.data.Exhibitors

            vm.$store.dispatch('updateLoading', false)
          })

        //紀錄瀏覽

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',
          // animation: false,
          allowEnterKey: true,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },
    },

    computed: {
      ...mapGetters([
        'ListStatus',
        'OptionKeyword',
        'Searchcountry',
        'SearchArea',
        'Roomvisible',
        'ShowRoom',
        'exhcode',
      ]),
    },
    created() {
      $('.modal').modal('hide')
      const vm = this
      this.$store.dispatch('ShowChatRoom', false)

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      //將vuex的資料匯出去變數裡

      vm.$store.dispatch('updateLoading', true)
      vm.currentPage = vm.$route.params.SearchExhPage

      vm.optionArea = vm.SearchArea.split(',')
      vm.optionCountry = vm.Searchcountry.split(',')

      vm.TemplateOptionKeyword = vm.OptionKeyword

      //取得過濾後的參展商列表

      vm.$http
        .get(
          `https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitors/${vm.exhcode}?AreaNo=${vm.SearchArea}&CatNo=&countrycode=${vm.Searchcountry}&keyword=${vm.OptionKeyword}&Type=null&Page=${vm.currentPage}&Lang=en&mode=page`
        )
        .then((response) => {
          vm.totalNo = response.data.DataTotal

          if (response.data.PageTotal > 0) {
            vm.hasResult = true

            vm.SearchExhibList = response.data.Exhibitors
            vm.totalPage = response.data.PageTotal

            for (let i = 0; i < vm.totalPage; i++) {
              if (i % 10 === 0) {
                vm.ProductRawData.push([])
              }

              const page = parseInt(i / 10)
              vm.ProductRawData[page].push(i + 1)
            }

            vm.totaltenPageNum = vm.ProductRawData.length
            let anaNowPage = vm.currentPage - 1

            vm.tenPageNum = parseInt(anaNowPage / 10)
            vm.showpage = vm.ProductRawData[vm.tenPageNum]
            vm.$store.dispatch('updateLoading', false)
          } else {
            alert('No result !')
            vm.hasResult = false

            vm.$store.dispatch('updateLoading', false)
          }
        })

      // 取得展場分區選項
      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibAreas/${vm.exhcode}?Lang=en`).then((response) => {
        if (response.data.length == 0) {
          vm.hasExhibAreas = false
        } else {
          vm.hasExhibAreas = true
        }

        vm.ExhibAreasList = response.data
        vm.ExhibAreasList.forEach((item) => {
          vm.categoryAll.push(item.AreaID)
        })
      })

      //取得國家列表
      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/ExhibitorCountries/${vm.exhcode}?Lang=en`)
        .then((response) => {
          vm.CountryList = response.data
          vm.CountryList.forEach((item) => {
            vm.countryAll.push(item.CountryCode)
          })
        })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  .logImgFrame {
    width: 200px;
    min-height: 145px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cardFrame {
    position: relative;

    .VipTag {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  .ComNameFrame {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ellipsis_exh {
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
  }
</style>
